const documents = {
    existingDocs: [],
    loadingDocs: true,
    ddlDocOptions: [],
    currentTemplate: [],
    loadingTemplates: true,
    selectedDoc: [],
    appUpdated: false
};

export default documents;
